import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { Select } from './ui/Select';
import { FilePlus, Copy } from 'lucide-react';
interface TemplateSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectTemplate: (templateId: string | null) => void;
}
export function TemplateSelectionModal({
  isOpen,
  onClose,
  onSelectTemplate
}: TemplateSelectionModalProps) {
  const [selectedTemplate, setSelectedTemplate] = useState<string>('');
  const handleCreateFromScratch = () => {
    onSelectTemplate(null);
  };
  const handleUseTemplate = () => {
    if (selectedTemplate) {
      onSelectTemplate(selectedTemplate);
    }
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Create New Loan Product" maxWidth="lg" data-id="element-1145">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1146">
        {/* Option 1: Create from Scratch */}
        <div className="border border-gray-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer group flex flex-col items-center text-center" onClick={handleCreateFromScratch} data-id="element-1147">
          <div className="h-12 w-12 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors" data-id="element-1148">
            <FilePlus className="h-6 w-6 text-blue-600" data-id="element-1149" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1150">
            Create from Scratch
          </h3>
          <p className="text-sm text-gray-500 mb-6" data-id="element-1151">
            Start with a completely blank product configuration.
          </p>
          <Button variant="secondary" className="w-full mt-auto" data-id="element-1152">
            Select Blank
          </Button>
        </div>

        {/* Option 2: Use Template */}
        <div className="border border-gray-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all flex flex-col items-center text-center" data-id="element-1153">
          <div className="h-12 w-12 bg-purple-50 rounded-full flex items-center justify-center mb-4" data-id="element-1154">
            <Copy className="h-6 w-6 text-purple-600" data-id="element-1155" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1156">
            Use Existing Template
          </h3>
          <p className="text-sm text-gray-500 mb-4" data-id="element-1157">
            Pre-fill configuration from a standard template.
          </p>

          <div className="w-full space-y-4 mt-auto" data-id="element-1158">
            <Select options={[{
            value: 'personal_std',
            label: 'Standard Personal Loan'
          }, {
            value: 'mortgage_fixed',
            label: 'Fixed Rate Mortgage'
          }, {
            value: 'sme_working',
            label: 'SME Working Capital'
          }]} value={selectedTemplate} onChange={e => setSelectedTemplate(e.target.value)} placeholder="Select a template..." data-id="element-1159" />
            <Button variant="primary" className="w-full" disabled={!selectedTemplate} onClick={handleUseTemplate} data-id="element-1160">
              Continue with Template
            </Button>
          </div>
        </div>
      </div>
    </Modal>;
}